<script>
// TODO: fade-inはtransform translateYしたいなどfadeとfade-inを分けたくなったときは分ける
export default {
  props: {
    mode: {
      type: String,
      default: 'out-in',
    },
    duration: {
      type: Number,
      default: 200,
    },
    timingFunction: {
      type: String,
      default: 'ease-out',
    },
  },
  render(h) {
    const transitionStyle = `opacity ${this.duration}ms ${this.timingFunction}`;

    return h(
      'transition',
      {
        props: {
          mode: this.mode,
          name: 'fade-in',
        },
        on: {
          beforeEnter(el) {
            el.style.transition = transitionStyle;
          },
          beforeLeave(el) {
            el.style.transition = transitionStyle;
          },
        },
      },
      this.$slots.default
    );
  },
};
</script>

<style lang="scss" scoped>
@import '~@/mikan/pc/base/constants';

.fade-in-enter,
.fade-in-leave-to {
  opacity: 0;
}
</style>
